import { Button, ButtonProps, styled } from '@mui/material';

interface ICustomButtonProps extends ButtonProps {
  fit?: boolean;
}

export const CustomButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'fit',
})<ICustomButtonProps>((props: ICustomButtonProps) => ({
  width: props.fit ? 'max-content' : '100%',
  minWidth: 'auto',
}));
